var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1876_63731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13484 7.82349C2.56383 9.86747 1.37922 12.2233 0.689453 14.7826H11.094L4.13484 7.82349Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3106 14.7828C38.6209 12.2236 37.4362 9.86772 35.8652 7.82373L28.9062 14.7828H39.3106Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.689453 25.2175C1.3793 27.7767 2.56391 30.1326 4.13484 32.1765L11.0938 25.2175H0.689453Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1778 4.13443C30.1338 2.56342 27.778 1.37881 25.2188 0.688965V11.0934L32.1778 4.13443Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82422 35.8656C9.8682 37.4367 12.2241 38.6213 14.7833 39.3111V28.9067L7.82422 35.8656Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7832 0.688965C12.224 1.37881 9.86812 2.56342 7.82422 4.13436L14.7832 11.0933V0.688965Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2188 39.3111C27.778 38.6213 30.1338 37.4367 32.1777 35.8657L25.2188 28.9067V39.3111Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9062 25.2175L35.8652 32.1766C37.4362 30.1327 38.6209 27.7767 39.3106 25.2175H28.9062Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3913H22.6088H22.6087V0.169297C21.7548 0.058125 20.8841 0 20 0C19.1157 0 18.2452 0.058125 17.3913 0.169297V17.3912V17.3913H0.169297C0.058125 18.2452 0 19.1159 0 20C0 20.8843 0.058125 21.7548 0.169297 22.6087H17.3912H17.3913V39.8307C18.2452 39.9419 19.1157 40 20 40C20.8841 40 21.7548 39.942 22.6087 39.8307V22.6088V22.6087H39.8307C39.9419 21.7548 40 20.8843 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2168 25.2176L34.1415 34.1423C34.552 33.732 34.9435 33.303 35.3171 32.8583L27.6763 25.2175H25.2168V25.2176Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7822 25.2175H14.782L5.85742 34.1421C6.26773 34.5526 6.69672 34.9442 7.14141 35.3178L14.7822 27.6768V25.2175Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.782 14.7828V14.7827L5.85727 5.85791C5.4468 6.26822 5.05523 6.69721 4.68164 7.14189L12.3225 14.7828H14.782V14.7828Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2168 14.7828L34.1416 5.85792C33.7312 5.44745 33.3023 5.05589 32.8576 4.68237L25.2168 12.3232V14.7828Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1876_63731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united_kingdom.ed3d93e08f95914793866ac2605d6543.svg";
export { ForwardRef as ReactComponent };